module.exports = __webpack_public_path__ + "static/media/female.03798421.svg";